/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const LOGS = {
  ORDER_BY: optionsProxy.create([
    { value: 'asc', get label() { return i18n.t('vlaccess:logs.constants.order_by.asc.label'); } },
    { value: 'desc', get label() { return i18n.t('vlaccess:logs.constants.order_by.desc.label'); } },
  ]),
};
